import type { ReactNode } from "react";

interface EmptyStateProps {
  icon?: string;
  title: string;
  description?: string;
  children?: ReactNode;
}

export default function EmptyState({
  icon = "ri-inbox-line",
  title,
  description,
  children,
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center rounded-lg border border-dashed border-background-300 bg-background-100/60 px-6 py-16 text-center">
      <span className="flex h-14 w-14 items-center justify-center rounded-full bg-background-200 text-foreground-500">
        <i className={`${icon} text-2xl`} />
      </span>
      <p className="mt-4 font-heading text-base font-semibold text-foreground-800">{title}</p>
      {description && (
        <p className="mt-2 max-w-md text-sm leading-relaxed text-foreground-500">{description}</p>
      )}
      {children && <div className="mt-5">{children}</div>}
    </div>
  );
}